(function() {
  'use strict';

  // ==========================================================
  // CONFIG
  // ==========================================================
  var FORM_ACTION_URL = 'https://script.google.com/macros/s/AKfycbw42J1SwowdtMWXO708vEKtuftlKo0N4ergkDjGgIl5nF7fGUw4fwY33tIzcT5CstKUIg/exec';

  // Offset added to spotsClaimed so the counter reflects spots already filled before the live tracker was wired up.
  var SPOTS_CLAIMED_OFFSET = 23;

  // Hardcoded variant ID for The Mini Spa Retreat
  // This is used for the Shopify AJAX Cart API (/cart/add.js)
  // ONLY works on the live Shopify site (same-origin)
  var VARIANT_ID = 44733186637975;

  // Cloudinary raw-video upload widget
  var CLOUDINARY_CLOUD_NAME = 'dupb9vzmp';
  var CLOUDINARY_UPLOAD_PRESET = 'ml_default';
  var CLOUDINARY_MAX_BYTES = 100000000; // 100 MB

  // ==========================================================
  // DEFAULT CAMPAIGN (fallback)
  // ==========================================================
  var DEFAULT_CAMPAIGN = {
    campaign: {
      name: 'The Mini Spa Retreat',
      productUrl: 'https://satavinaturals.com/products/the-mini-spa-retreat',
      productImage: 'https://satavinaturals.com/cdn/shop/files/mini-spa-retreat-gift-set-main.webp',
      price: '$32.99',
      description: 'Our curated spa gift set featuring bath bombs, sugar scrub, a candle, 24K gold eye masks, and a steam eye mask — everything you need for the ultimate at-home spa experience.',
      maxSpots: 50,
      active: true
    },
    spotsRemaining: null,
    spotsClaimed: null
  };

  // ==========================================================
  // VIDEO SOURCES (easy to swap later)
  // ==========================================================
  var VIDEO_SOURCES = [
    'https://cdn.shopify.com/videos/c/o/v/520cf6e932ca404c878d7090d4f796f9.mov',
    'https://cdn.shopify.com/videos/c/o/v/417f7ef7deba4b10a407fca238ab75d7.mov',
    'https://cdn.shopify.com/videos/c/o/v/573a43999f0d41f68364659717da66d8.mp4',
    'https://cdn.shopify.com/videos/c/o/v/7967d548a76f4fee8cd59b90448059fc.mp4',
    'https://cdn.shopify.com/videos/c/o/v/fd235b76e2ac48ad903b648df8df1ea0.mov',
    'https://cdn.shopify.com/videos/c/o/v/f98bdfd3e7494b34a945d938b38f4f74.mov',
    'https://cdn.shopify.com/videos/c/o/v/41fbcdf768ef458e9cb3b1b651635de2.mov',
    'https://cdn.shopify.com/videos/c/o/v/5e5a0dab1d9647cb9c8802612461aafa.mov'
  ];

  // ==========================================================
  // DOM REFS
  // ==========================================================
  var form = document.getElementById('cc-form');
  var formWrap = document.getElementById('cc-form-wrap');
  var submitBtn = document.getElementById('cc-submit-btn');
  var confirmation = document.getElementById('cc-confirmation');
  var campaignLoading = document.getElementById('cc-campaign-loading');
  var campaignCard = document.getElementById('cc-campaign-card');
  var campaignFull = document.getElementById('cc-campaign-full');
  var spotsContainer = document.getElementById('cc-spots');
  var spotsCount = document.getElementById('cc-spots-count');
  var spotsLabel = document.getElementById('cc-spots-label');
  var ringFg = document.getElementById('cc-spots-ring-fg');
  var RING_CIRCUMFERENCE = 2 * Math.PI * 52; // matches the SVG circle r=52
  var addToCartBtn = document.getElementById('cc-add-to-cart');
  var cartActions = document.getElementById('cc-cart-actions');
  var uploadBtn = document.getElementById('cc-upload-btn');
  var uploadStatus = document.getElementById('cc-upload-status');
  var videoFileUrlInput = document.getElementById('cc-videoFileUrl');

  var isCampaignFull = false;
  var uploadedFileName = '';

  // ==========================================================
  // CAMPAIGN DATA LOADING
  // ==========================================================
  function loadCampaign() {
    if (FORM_ACTION_URL === 'REPLACE_WITH_YOUR_GOOGLE_APPS_SCRIPT_URL') {
      showCampaign(DEFAULT_CAMPAIGN);
      return;
    }
    fetch(FORM_ACTION_URL)
      .then(function(res) { return res.json(); })
      .then(function(data) { showCampaign(data); })
      .catch(function() { showCampaign(DEFAULT_CAMPAIGN); });
  }

  function showCampaign(data) {
    var c = data.campaign;
    document.getElementById('cc-campaign-name').textContent = c.name;
    document.getElementById('cc-campaign-price').textContent = c.price;
    document.getElementById('cc-campaign-desc').textContent = c.description;
    document.getElementById('cc-campaign-image').src = c.productImage;
    document.getElementById('cc-campaign-image').alt = c.name;

    // Update Add to Cart button text
    addToCartBtn.innerHTML = 'Add to Cart &mdash; ' + c.price;

    // Spots counter — progress bar fills with offset-adjusted claim count
    var maxSpots = (typeof c.maxSpots === 'number' && c.maxSpots > 0) ? c.maxSpots : 50;
    var rawRemaining = (data.spotsRemaining !== null && data.spotsRemaining !== undefined) ? Number(data.spotsRemaining) : maxSpots;
    var spotsClaimed = (data.spotsClaimed !== null && data.spotsClaimed !== undefined) ? Number(data.spotsClaimed) : Math.max(0, maxSpots - rawRemaining);
    if (!isFinite(spotsClaimed)) spotsClaimed = 0;

    // Formula: percentage = (spotsClaimed + SPOTS_CLAIMED_OFFSET) / maxSpots * 100
    var totalClaimed = Math.min(maxSpots, spotsClaimed + SPOTS_CLAIMED_OFFSET);
    var remaining = Math.max(0, maxSpots - totalClaimed);
    var percentage = Math.max(0, Math.min(100, (totalClaimed / maxSpots) * 100));

    spotsCount.textContent = remaining;
    spotsLabel.textContent = 'of ' + maxSpots + ' spots remaining';
    if (remaining <= 0) {
      isCampaignFull = true;
    } else if (remaining <= 5) {
      spotsContainer.classList.add('cc-spots--urgent');
      spotsLabel.textContent = 'Only ' + remaining + ' spot' + (remaining === 1 ? '' : 's') + ' left!';
    }

    // Donut ring: drive the teal arc via stroke-dashoffset.
    // dashoffset = circumference * (1 - pct/100), so 0% = hidden, 100% = fully drawn.
    if (ringFg) {
      var dashoffset = RING_CIRCUMFERENCE * (1 - percentage / 100);
      ringFg.setAttribute('stroke-dasharray', RING_CIRCUMFERENCE);
      ringFg.setAttribute('stroke-dashoffset', dashoffset);
    }

    if (!c.active || isCampaignFull) {
      campaignFull.classList.add('cc-visible');
      formWrap.style.display = 'none';
      addToCartBtn.disabled = true;
      if (isCampaignFull) {
        spotsCount.textContent = '0';
        spotsLabel.textContent = 'of ' + maxSpots + ' spots remaining';
        if (ringFg) ringFg.setAttribute('stroke-dashoffset', 0);
      }
    }

    campaignLoading.style.display = 'none';
    campaignCard.style.display = 'block';
  }

  loadCampaign();

  // ==========================================================
  // ADD TO CART (Shopify AJAX Cart API)
  // ==========================================================
  var isOnShopify = (window.location.hostname.indexOf('satavinaturals.com') !== -1 ||
                     window.location.hostname.indexOf('myshopify.com') !== -1);

  addToCartBtn.addEventListener('click', function() {
    if (addToCartBtn.disabled) return;

    if (!isOnShopify) {
      addToCartBtn.textContent = 'Preview mode — works on live site';
      addToCartBtn.disabled = true;
      setTimeout(function() {
        addToCartBtn.innerHTML = 'Add to Cart &mdash; $32.99';
        addToCartBtn.disabled = false;
      }, 2500);
      return;
    }

    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart error');
      return res.json();
    })
    .then(function() {
      addToCartBtn.innerHTML = 'Added! &#10003;';
      addToCartBtn.classList.add('cc-btn--success');
      addToCartBtn.style.animation = 'cc-checkPop 0.3s ease';
      cartActions.style.display = 'block';
      setTimeout(function() {
        addToCartBtn.innerHTML = 'Add to Cart &mdash; $32.99';
        addToCartBtn.classList.remove('cc-btn--success');
        addToCartBtn.style.animation = '';
        addToCartBtn.disabled = false;
      }, 3000);
    })
    .catch(function() {
      addToCartBtn.textContent = 'Something went wrong — try again';
      addToCartBtn.disabled = false;
      setTimeout(function() {
        addToCartBtn.innerHTML = 'Add to Cart &mdash; $32.99';
      }, 2500);
    });
  });

  // ==========================================================
  // CLIENT-SIDE VALIDATION
  // ==========================================================
  var validators = {
    fullName: function(val) { return val.trim().length >= 2; },
    email: function(val) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val); },
    orderNumber: function(val) { return val.trim().length >= 1; },
    socialHandle: function(val) { return val.trim().length >= 2; },
    platform: function(val) { return val !== ''; },
    postLink: function(val) { return /^https?:\/\/.+\..+/.test(val.trim()); },
    rightsAgreed: function(_val, el) { return el.checked; }
  };

  function setFieldError(fieldName, hasError) {
    var wrapper = form.querySelector('[data-field="' + fieldName + '"]');
    if (!wrapper) return;
    if (hasError) {
      wrapper.classList.add('cc-field--error');
      if (fieldName === 'rightsAgreed') wrapper.classList.add('cc-checkbox--error');
    } else {
      wrapper.classList.remove('cc-field--error', 'cc-checkbox--error');
    }
  }

  function validateForm() {
    var isValid = true;
    Object.keys(validators).forEach(function(fieldName) {
      var el = form.querySelector('[name="' + fieldName + '"]');
      if (!el) return;
      var val = el.type === 'checkbox' ? '' : el.value;
      var valid = validators[fieldName](val, el);
      setFieldError(fieldName, !valid);
      if (!valid) isValid = false;
    });
    return isValid;
  }

  form.addEventListener('input', function(e) {
    var name = e.target.name;
    if (name && validators[name]) {
      var val = e.target.type === 'checkbox' ? '' : e.target.value;
      if (validators[name](val, e.target)) setFieldError(name, false);
    }
  });
  form.addEventListener('change', function(e) {
    var name = e.target.name;
    if (name && validators[name]) {
      var val = e.target.type === 'checkbox' ? '' : e.target.value;
      if (validators[name](val, e.target)) setFieldError(name, false);
    }
  });

  // ==========================================================
  // CLOUDINARY VIDEO UPLOAD (optional field)
  // ==========================================================
  if (uploadBtn && uploadStatus && videoFileUrlInput) {
    var cloudinaryWidget = null;

    function setUploadStatus(state, message) {
      uploadStatus.className = 'cc-upload__status cc-upload__status--' + state;
      uploadStatus.innerHTML = message;
    }

    function openUploadWidget() {
      if (typeof window.cloudinary === 'undefined' || !window.cloudinary.createUploadWidget) {
        setUploadStatus('error', 'Upload widget failed to load. Please refresh and try again.');
        return;
      }
      if (!cloudinaryWidget) {
        cloudinaryWidget = window.cloudinary.createUploadWidget({
          cloudName: CLOUDINARY_CLOUD_NAME,
          uploadPreset: CLOUDINARY_UPLOAD_PRESET,
          resourceType: 'video',
          sources: ['local'],
          multiple: false,
          maxFileSize: CLOUDINARY_MAX_BYTES,
          clientAllowedFormats: ['mp4', 'mov', 'm4v', 'quicktime'],
          showPoweredBy: false
        }, function(error, result) {
          if (error) {
            setUploadStatus('error', 'Upload failed: ' + (error.message || 'please try again.'));
            uploadBtn.disabled = false;
            uploadBtn.textContent = 'Upload Video';
            return;
          }
          if (!result || !result.event) return;

          if (result.event === 'upload-added') {
            uploadBtn.disabled = true;
            uploadBtn.textContent = 'Uploading 0%';
            setUploadStatus('uploading', 'Preparing upload\u2026');
          } else if (result.event === 'progress') {
            var pct = 0;
            if (result.info && typeof result.info.bytes === 'number' && typeof result.info.totalBytes === 'number' && result.info.totalBytes > 0) {
              pct = Math.min(100, Math.round((result.info.bytes / result.info.totalBytes) * 100));
            }
            uploadBtn.textContent = 'Uploading ' + pct + '%';
            setUploadStatus('uploading', 'Uploading your video\u2026 ' + pct + '%');
          } else if (result.event === 'success') {
            var info = result.info || {};
            uploadedFileName = info.original_filename
              ? (info.original_filename + (info.format ? '.' + info.format : ''))
              : 'video uploaded';
            videoFileUrlInput.value = info.secure_url || '';
            uploadBtn.disabled = false;
            uploadBtn.textContent = 'Replace Video';
            setUploadStatus(
              'success',
              '<span class="cc-upload__check" aria-hidden="true">&#10003;</span> ' +
              '<span class="cc-upload__filename"></span>'
            );
            var fnEl = uploadStatus.querySelector('.cc-upload__filename');
            if (fnEl) fnEl.textContent = uploadedFileName;
          } else if (result.event === 'abort' || result.event === 'close') {
            // If no file was chosen or the user bailed mid-upload, reset the button if nothing stored yet.
            if (!videoFileUrlInput.value) {
              uploadBtn.disabled = false;
              uploadBtn.textContent = 'Upload Video';
            }
          }
        });
      }
      cloudinaryWidget.open();
    }

    uploadBtn.addEventListener('click', openUploadWidget);
  }

  // ==========================================================
  // FORM SUBMISSION
  // ==========================================================
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    if (isCampaignFull) {
      alert('Sorry, this campaign is full. Follow us on Instagram for the next one!');
      return;
    }
    if (!validateForm()) {
      var firstError = form.querySelector('.cc-field--error, .cc-checkbox--error');
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var feedbackEl = document.getElementById('cc-feedback');
    var payload = {
      fullName: form.fullName.value.trim(),
      email: form.email.value.trim(),
      orderNumber: form.orderNumber.value.trim(),
      socialHandle: form.socialHandle.value.trim(),
      platform: form.platform.value,
      postLink: form.postLink.value.trim(),
      videoFileUrl: videoFileUrlInput ? videoFileUrlInput.value.trim() : '',
      affiliateInterest: document.getElementById('affiliateInterest') ? document.getElementById('affiliateInterest').checked ? 'Yes' : 'No' : 'No',
      feedback: feedbackEl ? feedbackEl.value.trim() : '',
      rightsAgreed: form.rightsAgreed.checked ? 'Yes' : 'No'
    };

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting\u2026';

    fetch(FORM_ACTION_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(payload)
    })
    .then(function() { showConfirmation(); })
    .catch(function(err) {
      console.error('Submission error:', err);
      submitBtn.disabled = false;
      submitBtn.textContent = 'Submit My Video';
      alert('Something went wrong. Please check your connection and try again.');
    });
  });

  function showConfirmation() {
    formWrap.style.display = 'none';
    confirmation.classList.add('cc-show');
    confirmation.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // ==========================================================
  // FAQ ACCORDION
  // ==========================================================
  document.querySelectorAll('.cc-accordion__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.parentElement;
      var body = item.querySelector('.cc-accordion__body');
      var isOpen = item.classList.contains('cc-open');
      document.querySelectorAll('.cc-accordion__item').forEach(function(el) {
        el.classList.remove('cc-open');
        el.querySelector('.cc-accordion__body').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('cc-open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  // ==========================================================
  // VIDEO CAROUSEL — scroll arrows
  // ==========================================================
  var carousel = document.getElementById('cc-carousel');
  var leftArrow = document.getElementById('cc-carousel-left');
  var rightArrow = document.getElementById('cc-carousel-right');

  if (leftArrow && rightArrow && carousel) {
    function getCarouselPageWidth() {
      var visibleWidth = carousel.clientWidth;
      var cards = carousel.querySelectorAll('.cc-carousel__card');
      if (!cards.length) return visibleWidth;
      var cardStyle = window.getComputedStyle(cards[0]);
      var cardWidth = cards[0].offsetWidth;
      var gap = parseFloat(window.getComputedStyle(carousel).gap) || 14;
      var cardStep = cardWidth + gap;
      var visibleCards = Math.floor(visibleWidth / cardStep);
      if (visibleCards < 1) visibleCards = 1;
      return visibleCards * cardStep;
    }
    leftArrow.addEventListener('click', function() {
      carousel.scrollBy({ left: -getCarouselPageWidth(), behavior: 'smooth' });
    });
    rightArrow.addEventListener('click', function() {
      carousel.scrollBy({ left: getCarouselPageWidth(), behavior: 'smooth' });
    });
  }

  // ==========================================================
  // VIDEO LIGHTBOX
  // ==========================================================
  var lightbox = document.getElementById('cc-lightbox');
  var lightboxVideo = document.getElementById('cc-lightbox-video');
  var lightboxClose = document.getElementById('cc-lightbox-close');
  var lightboxPrev = document.getElementById('cc-lightbox-prev');
  var lightboxNext = document.getElementById('cc-lightbox-next');
  var currentVideoIndex = 0;

  function openLightbox(index) {
    currentVideoIndex = index;
    lightboxVideo.src = VIDEO_SOURCES[index];
    lightboxVideo.muted = false;
    lightboxVideo.play().catch(function() {});
    lightbox.classList.add('cc-active');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('cc-active');
    lightboxVideo.pause();
    lightboxVideo.removeAttribute('src');
    lightboxVideo.load();
    document.body.style.overflow = '';
  }

  function navigateLightbox(dir) {
    currentVideoIndex = (currentVideoIndex + dir + VIDEO_SOURCES.length) % VIDEO_SOURCES.length;
    lightboxVideo.src = VIDEO_SOURCES[currentVideoIndex];
    lightboxVideo.muted = false;
    lightboxVideo.play().catch(function() {});
  }

  // Click on carousel cards
  document.querySelectorAll('.cc-carousel__card').forEach(function(card) {
    card.addEventListener('click', function() {
      var idx = parseInt(card.getAttribute('data-video-index'));
      openLightbox(idx);
    });
  });

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxPrev) lightboxPrev.addEventListener('click', function() { navigateLightbox(-1); });
  if (lightboxNext) lightboxNext.addEventListener('click', function() { navigateLightbox(1); });

  // Close on background click
  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) closeLightbox();
  });

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (!lightbox.classList.contains('cc-active')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') navigateLightbox(-1);
    if (e.key === 'ArrowRight') navigateLightbox(1);
  });

  // ==========================================================
  // SMOOTH SCROLL for anchor links
  // ==========================================================
  document.querySelectorAll('.cc-page a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ==========================================================
  // SCROLL ANIMATIONS
  // ==========================================================
  if ('IntersectionObserver' in window) {
    var animObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cc-visible');
          animObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.cc-animate').forEach(function(el) {
      animObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.cc-animate').forEach(function(el) {
      el.classList.add('cc-visible');
    });
  }

})();

